export default "__VITE_ASSET__c206282d__"